package com.klantenstop.web.data.models.dto.requests.user

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertNewUser(
    @SerialName("first_name")
    val firstName: String,
    @SerialName("last_name")
    val lastName: String,
    val email: String,
    val password: String,
    @SerialName("repeat_password")
    val repeatPassword: String?
) {
    val isValid get() = firstName.isNotBlank() && lastName.isNotBlank() && password.isNotBlank() && repeatPassword?.isNotBlank() == true && email.isNotBlank()
}
